import React, { useState } from 'react';

const PitchBlock = ({
  blockIndex,
  pitch,
  time,
  pitchIndex,
  timeRange,
  isSlotSelectedInCart,
  alreadyBooked,
  isPitchAvailable,
  isSlotDeleatable,
  is8A,
  selectedPitchIcon,
  handleBoxClick,
  removeFromCart,
  selectedDate,
  isSlotInBuffer,
  slotDurationHours
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const getDurationDisplay = (timeRange) => {
  if (!timeRange || !timeRange.includes('-')) return '(0hr)';

  const [startTime, endTime] = timeRange.split('-').map(t => t.trim());
  
  // Simple conversion from 12h to 24h format
  const convertTo24 = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':');
    
    hours = parseInt(hours);
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    
    return hours + (minutes ? parseInt(minutes)/60 : 0);
  };

  // Calculate hours (handles both AM/PM and 24h formats)
  const start = convertTo24(startTime);
  const end = convertTo24(endTime);
  let duration = Math.abs(end - start);
  
  // Handle overnight slots (e.g. 11PM-1AM)
  if (end < start) duration = 24 - start + end;
  
  // Round to handle floating point precision
  duration = Math.round(duration * 100) / 100;
  
  const hourText = duration === 1 ? 'hr' : 'hr';
  return `${duration}${hourText}`;
};


  function formatDate(date) {
    if (!date) {
      return "";
    }

    if (!(date instanceof Date)) {
      // Attempt to create a Date object from the input
      date = new Date(date);
    }

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ""; // Return an empty string if date is invalid
    }

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return `${day} ${months[monthIndex]} ${year}`;
  }

  const backgroundColor = isSlotSelectedInCart(pitch, timeRange)
  ? 'green'
  : alreadyBooked || isPitchAvailable
    ? 'lightgray'
    : isSlotInBuffer
    ? 'pink'
    : 'white';

  const isPinkSlot = backgroundColor === 'pink';

  return (
    <div
      key={`${pitchIndex}-${blockIndex}`}
      style={{
        position: 'relative', // Needed for absolute positioning of tooltip
        backgroundColor: backgroundColor,
        borderColor:
          alreadyBooked || isPitchAvailable
            ? '#8F8F8F'
            : isSlotInBuffer 
            ? '#FFB6C1'
            : '#48c14c',
        cursor: isSlotDeleatable(pitch, timeRange)
          ? 'pointer'
          : isSlotSelectedInCart(pitch, timeRange) ||
            alreadyBooked ||
            isPitchAvailable ||
            isSlotInBuffer ||
            (is8A && pitchIndex % 3 !== 0)
            ? 'not-allowed'
            : 'pointer',
      }}
      onMouseEnter={() => isPinkSlot && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={() => {
        if (
          alreadyBooked ||
          isPitchAvailable ||
          isSlotInBuffer ||
          (is8A && pitchIndex % 3 !== 0)
        ) {
          return;
        }
        if (
          isSlotSelectedInCart(pitch, timeRange) &&
          isSlotDeleatable(pitch, timeRange)
        ) {
          removeFromCart(pitch.name, timeRange, formatDate(selectedDate));
        }
         else if (!isSlotSelectedInCart(pitch, timeRange)) {
          console.log("handlebox",pitch,timeRange)
          handleBoxClick(pitch, timeRange,false,selectedDate);
        }
      }}
      className="pitch-box-style"
    >
      
     <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
        {pitch.pitch_name}
        <span style={{ color: 'red', marginLeft: '2px' }}>
          {getDurationDisplay(timeRange)}
        </span>
      </div>
      
      {/* Tooltip that appears only for pink slots on hover */}
      {isPinkSlot && showTooltip && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 10,
          minWidth: '200px',
          textAlign: 'center',
          marginTop: '5px'
        }}>
          Call 6344 9345 to make a booking
        </div>
      )}
    </div>
  );
};

export default PitchBlock;
